module.exports = __webpack_public_path__ + "img/left2@2x.25187da4.png";